module.exports = __webpack_public_path__ + "static/media/github.48413ef9.png";